// export const API_BASE_URL =
//   "https://dev-boton-suscripcion.qbitos.com/boton-prescipcion-back/api/";

const isLocalhost =
	typeof window !== "undefined" &&
	["localhost", "127.0.0.1"].includes(window.location.hostname);

export const API_BASE_URL =
	process.env.NODE_ENV === "development" && isLocalhost
		? "/api/"
		: process.env.REACT_APP_API_BASE_URL;
  
export const CONNECTION_ERROR = "No se puede conectar en este momento inténtelo más tarde.";

// Versión de la aplicación mostrada en el menú lateral del backoffice.
export const APP_VERSION = "1.0";

//caso prueba
//"https://dev-boton-suscripcion.qbitos.com/boton-prescipcion-front/formulario/4ea54202-fe01-4646-8445-9f4d2c3a9820"
//http://localhost:3000/boton-prescipcion-front/formulario/4ea54202-fe01-4646-8445-9f4d2c3a9820

//"https://dev-boton-suscripcion.qbitos.com/boton-prescipcion-front/formulario/8f49534f-d258-4297-9ba3-977737ff6f60"
